<template>
  <div class="app-layout">
    <!-- 全局页头 -->
    <div class="header-section">
      <div class="login-info">
        <span class="welcome-text">欢迎,</span>
        <span class="user-role">{{ username }}</span>
      </div>
      <div class="actions-section">
        <button class="action-btn" @click="logout">
          <span>🚪</span> <span class="btn-text">登出</span>
        </button>
      </div>
    </div>

    <div class="main-content">
      <div class="page-container" :class="{ 'no-sidebar': true, 'mobile-container': isMobile }">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLayout',
  data() {
    return {
      username: '',
      userRole: '',
      isMobile: false
    };
  },
  created() {
    this.getUserInfo();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    logout() {
      // 客户登出
      localStorage.removeItem('username');
      localStorage.removeItem('userRole');
      localStorage.removeItem('customerInfo');
      this.$router.push('/customer/login');
    },
    getUserInfo() {
      // 客户登录，从 localStorage 获取信息
      const userRole = localStorage.getItem('userRole');
      if (userRole === 'customer') {
        const username = localStorage.getItem('username');
        if (username) {
          this.username = username;
          this.userRole = 'customer';
        } else {
          this.$router.push('/customer/login');
        }
      } else {
        // 未登录，跳转到客户登录页
        this.$router.push('/customer/login');
      }
    }
  }
};
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
}

.login-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.welcome-text {
  font-size: 16px;
  color: #64748b;
}

.user-role {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.actions-section {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #1e293b;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.action-btn span {
  font-size: 14px;
}

.main-content {
  display: flex;
  flex: 1;
  min-height: 0;
}

.side-nav {
  width: 200px;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  padding: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}

.nav-item {
  display: block;
  padding: 12px 32px;
  color: #334155;
  font-size: 14px;
  text-decoration: none;
  border-left: 4px solid transparent;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.nav-item:hover {
  background: #f1f5f9;
  color: #4f46e5;
}

.nav-item.active, 
.nav-item.router-link-exact-active {
  background: #e0e7ff;
  color: #4f46e5;
  border-left: 4px solid #4f46e5;
  font-weight: 600;
}

.page-container {
  flex-grow: 1;
  overflow-y: auto;
  padding: 32px;
  background: #f6f8fa;
  min-height: 0;
}

.page-container.no-sidebar {
  width: 100%;
  padding: 32px;
  background: #f6f8fa;
  min-height: 0;
}

/* 移动端响应式设计 */
@media (max-width: 768px) {
  .header-section {
    padding: 12px 16px;
    //flex-direction: column;
    //gap: 12px;
    //align-items: stretch;
    display: flex;
    justify-content: space-between; /* 两端对齐 */
    align-items: center;           /* 垂直居中，可选 */
  }

  .login-info {
    justify-content: center;
  }

  .actions-section {
    justify-content: center;
  }

  .btn-text {
    //display: none;
    font-size: 12px;
  }

  .main-content {
    flex-direction: column;
  }

  .side-nav.mobile-nav {
    width: 100%;
    flex-direction: row;
    padding: 16px;
    gap: 8px;
    overflow-x: auto;
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }

  .side-nav.mobile-nav .nav-item {
    padding: 8px 16px;
    border-left: none;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    font-size: 12px;
  }

  .side-nav.mobile-nav .nav-item.active,
  .side-nav.mobile-nav .nav-item.router-link-exact-active {
    border-left: none;
    border-bottom: 2px solid #4f46e5;
  }

  .page-container.mobile-container {
    padding: 16px;
  }

  .page-container.no-sidebar.mobile-container {
    padding: 16px;
  }
}

/* 小屏幕设备 */
@media (max-width: 480px) {
  .header-section {
    padding: 8px 12px;
  }

  .welcome-text,
  .user-role {
    font-size: 14px;
  }

  .side-nav.mobile-nav {
    padding: 12px;
  }

  .side-nav.mobile-nav .nav-item {
    padding: 6px 12px;
    font-size: 11px;
  }

  .page-container.mobile-container {
    padding: 12px;
  }
}
</style>
